import { Box } from "@mui/material";
import styled from "styled-components";

export const ContainerTitleStyled = styled(Box)`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  margin-bottom: 27px;
  .title-and-back-icon {
    display: flex;
    align-items: center;
    gap: 12px;
    .back-icon {
      width: 28px;
      height: 28px;
      cursor: pointer;
      svg {
        width: 100%;
        height: 100%;
        display: block;
        color: var(--medium-gray-color);
      }
    }
    .title {
      font-weight: 600;
      font-size: 36px;
      color: var(--dark-gray-color);
      @media (max-width: 768px) {
        font-size: 24px !important;
      }

      @media (max-width: 576px) {
        font-size: 16px !important;
      }
    }
  }
`;
